export function authHeader(userToken) {
    if (userToken !== ""){
        return { 'Content-Type': 'application/json',  'Authorization': `Bearer ${userToken}` };
    } else {
        return {};
    }   
}

export function authFileHeader(userToken) {
    if (userToken !== ""){
        return { 'Authorization': `Bearer ${userToken}` };
    } else {
        return {};
    }
    
}